module.exports = __webpack_public_path__ + "static/media/chakli.fe26d454.jpg";